import { render } from "./SetInitialPassword.vue?vue&type=template&id=6bdf74ba"
import script from "./SetInitialPassword.vue?vue&type=script&lang=js"
export * from "./SetInitialPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__